<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header -->
      <b-navbar class="p-0" toggleable="lg" :type="isDark ? 'dark' : 'light'" :variant="isDark ? 'dark' : 'light'">
          <b-navbar-brand class="ml-4">
          <strong>Requisição</strong>
          <small> Lista</small>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse" />
        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button class="px-2" type="button" :variant="isDark ? 'dark' : 'light'" > 
                   <span style="font-size: 1.2rem" > <i  class="fa fa-question-circle"></i></span>
                </b-button>  
                
                <b-button class="px-2" type="reset" :variant="isDark ? 'dark' : 'light'" @click.stop.prevent="limparFiltro()">
                  <span style="font-size: 1.2rem" > <i  class="fa fa-ban"></i></span>
                </b-button>                            
                <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarHtml()" title="Imprimir/HTML" v-b-tooltip.hover.bottom> 
                   <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
                </b-button>
                <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarExcel()" title="Exportar Excel" v-b-tooltip.hover.bottom> 
                   <span style="font-size: 1.2rem" > <i  class="fa fa-file-excel-o"></i></span>
                </b-button>
                <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarCsv()" title="Exportar CSV" v-b-tooltip.hover.bottom> 
                   <span style="font-size: 1.2rem" > <i  class="fa fa-file-text-o"></i></span>
                </b-button>
                
                <b-form-input  type="date" ref="dt1" placeholder="Informe a data Inicio" v-model="dt1" @keydown.enter="pesquisar()"
                                  class="ml-2 px-2 bg-white" > </b-form-input>
                <b-form-input  type="date" ref="dt2" placeholder="Informe a data Término" v-model="dt2" @keydown.enter="pesquisar()"
                                class="ml-2 px-2 bg-white" >  <span  ></span> </b-form-input>   
                <b-button class="ml-2" pill type="button"   variant="primary" @click.stop.prevent="pesquisar()">
                  <b-icon icon="search" aria-hidden="true"></b-icon> Filtrar
                </b-button>                   
                <div class="d-inline-block">                              
                  <b-button class="ml-2" pill variant="teal" ref="btAdicionar" type="button" @click.stop.prevent="abrirModalRequisicaoAdd()" > 
                    <b-icon icon="plus" aria-hidden="true" font-scale="1.2"></b-icon> Requisição
                  </b-button>
                </div>
                
                
              </b-nav-form>
            </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <!-- Tabela -->
      <b-row>
        <b-col sm="12">
          <b-table 
            class="table table-sm mb-2"
            id="table-transition-example"
            ref="tbl"
            :dark="isDark"
            :items="itensFiltrados"
            :fields="colunas"
            :per-page="perPage"
            :current-page="currentPage"
            :sticky-header="stickyHeight"
            :tbody-tr-class="rowClassSelecionado"
            :head-variant="isDark ? 'dark' : 'light'"
            hover 
            small 
            bordered 
            @row-clicked="clicarLinha"
            @row-dblclicked="abrirModalRequisicaoEdit"
            show-empty
            empty-text="Informe o filtro para ver os registros "
            responsive 
            >
          
            <!-- Cabeçalho: ID -->
            <template #head(ID)>
              <SetFilter
                label="Requisição"
                v-model="filtros.ID"
                :options="opcoes.ID"
                :normalizeFn="normalize"
                dropdown-variant="outline-light"
              />
            </template>

            <!-- Cabeçalho: Situação -->
            <template #head(OP_STATUS)>
              <SetFilter
                label="Situação"
                v-model="filtros.OP_STATUS"
                :options="opcoes.OP_STATUS"
                :normalizeFn="normalize"
                dropdown-variant="outline-light"
              />
            </template>
            <!-- Cabeçalho: Situação -->
            <template #head(NOME_REQUISITANTE)>
              <SetFilter
                label="Requisitante"
                v-model="filtros.NOME_REQUISITANTE"
                :options="opcoes.NOME_REQUISITANTE"
                :normalizeFn="normalize"
                dropdown-variant="outline-light"
              />
            </template>
             <template #empty>
              <div class="h-100 d-flex align-items-center justify-content-center">
                Nenhum registro encontrado
              </div>
            </template>
            <template #cell(DETALHE)="row">
              <i 
                    :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                      @click.stop="toggleDetalhesListagem(row)"
                    style="cursor: pointer"
                  ></i>
                </template>
                <template #row-details="row">
                  <div v-if="row.item.loading">
                    Carregando detalhes...
                  </div>
                  <div v-else>
                    <b-table 
                      head-variant="dark"
                      hover="false"
                      :table-variant="isDark ? 'primary' : 'light'"
                      
                      :items="row.item.detalhes" 
                      :fields="detalhes.fields">
                      <template #cell(STATUS_ATENDIMENTO)="item">
                        <b-badge pill :variant="colorirSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)" >{{traduzSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                      </template>
                    </b-table>
                  </div>
                </template>      
                <template #cell(OP_STATUS)="item">
                  <b-badge pill :variant="colorirOP_STATUS(item.item.OP_STATUS)" >{{traduzOP_STATUS(item.item.OP_STATUS)}} </b-badge>
                </template>
                <template #cell(actions)="item">
                  <b-button v-if="(item.item.OP_STATUS == '1' || item.item.OP_STATUS == '3')" type="button"  @click.stop.prevent="abrirModalAcompanhamento(item.item)" size="sm" variant="gray-700" >
                    <i class="fa fa-eye"></i>
                  </b-button>
                  <b-button v-if="(item.item.OP_STATUS == '1' || item.item.OP_STATUS == '2')" type="button"  @click.stop.prevent="abrirModalAtendimento(item.item)" size="sm" variant="gray-700" >
                    <i class="fa fa-shopping-basket"></i>
                  </b-button>
                  
                  <b-button-group size="sm" >
                    <b-dropdown
                        right
                        dropup 
                        boundary="viewport"
                        :popper-opts="{ positionFixed: true }"
                        no-caret
                        variant="gray-700"
                        toggle-class="px-2 d-inline-flex align-items-center btn-icon-only"
                        @shown="clicarMenuLinha(item.item)"
                    >
                      <template #button-content>
                        <i class="fa fa-print" @click="clicarMenuLinha(item.item)"></i>
                      </template>
                      <b-dropdown-item 
                        @click="imprimirAtendimento(item.item)">
                        <i class="fa fa-print text-gray-700"></i>Atendimento
                      </b-dropdown-item>
                      <b-dropdown-item 
                          @click="imprimirRequisicao(item.item)">
                          <i class="fa fa-print text-gray-700"></i>Requisição
                      </b-dropdown-item>
                      

                    </b-dropdown>
                  </b-button-group>

                  
                  
                </template>
          </b-table>
        </b-col>
      </b-row>
      
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REQUISICAO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-requisicao" 
          id="modal-requisicao" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="REQUISICAO DO ALMOXARIFADO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 REQUISICAO DO ALMOXARIFADO: <strong>{{ requisicao.ID }}</strong>
              </div>
            </div>
            <b-row>
              <b-col sm="2">
                <b-form-fieldset label="Data">
                  <b-form-input  type="date" 
                                id="ob_dtDocumento" 
                                v-model="requisicao.DATA_CADASTRO"
                                :class="{'vazio': !requisicao.DATA_CADASTRO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Cadastro">
                  <b-form-input type="text" id="edUsuarioCadastro" :disabled="true"  v-model="requisicao.USUARIO_CADASTRO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
              <b-col sm="2">
                <b-form-fieldset label="Situação">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text ><strong :class="['fa fa-circle',
                                                            colorirOP_STATUS_MODAL(requisicao.OP_STATUS)]" ></strong></b-input-group-text>
                    </template>
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzOP_STATUS(requisicao.OP_STATUS)"></b-form-input>
                  </b-input-group>
                </b-form-fieldset>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="4">
                <b-form-fieldset label="Requisitante">
                  <b-form-select 
                      v-model="requisicao.REQUISITANTE_ID" 
                      ref="comboID_UNIDADE_COMERCIAL"
                      :options="optionsREQUISITANTE_ID"  
                      :state="!!requisicao.REQUISITANTE_ID"
                      >
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Centro de Custo">
                  <b-form-select 
                      v-model="requisicao.CENTRO_CUSTO_ID" 
                      ref="comboCENTRO_CUSTO_ID"
                      :options="optionsCENTRO_CUSTO_ID"  
                      :state="!!requisicao.CENTRO_CUSTO_ID"
                      >
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Departamento">
                  <b-form-select 
                      v-model="requisicao.DEPARTAMENTO_ID" 
                      ref="comboDEPARTAMENTO_ID"
                      :options="optionsDEPARTAMENTO_ID"  
                      :state="!!requisicao.DEPARTAMENTO_ID"
                      >
                  </b-form-select>
                </b-form-fieldset>
              </b-col>
            </b-row>
            <b-row class=" mt-0 mb-1 text-right">
                <b-col sm="12">
                  <b-button 
                            variant="success" 
                            ref="btAdicionarItem"
                            @click.stop="abrirModalItemRequisicaoAdd"
                            v-b-popover.hover.left="'Incluir Movimentação'" > 
                        <i class="fa fa-plus"></i> Incluir Item 
                  </b-button>
                </b-col>
              
              </b-row>
            
            <div>
              <b-table 
                bordered    
                striped 
                hover 
                show-empty
                empty-text="Nenhuma compra"
                stacked="md"
                small
                @row-clicked="abrirModalItemRequisicaoEdit"
                :per-page="modalRequisicao.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="modalRequisicao.currentPage"
                :items="modalRequisicao.items" 
                :fields="modalRequisicao.fields">
                <template #cell(RAZAOSOCIAL)="row">
                  {{ row.item.RAZAOSOCIAL }} - {{ row.item.FORNECEDOR_ID }} 
                </template>
                <template #cell(actions)="item">
                  <b-button type="button" @click.stop.prevent="deleteItemRequisicao(item.item)" size="sm" variant="danger " >
                    <i class="fa fa-times"></i>
                  </b-button>
                </template>
                <template #cell(STATUS_ATENDIMENTO)="item">
                  <b-badge pill :variant="colorirSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)" >{{traduzSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button v-if="requisicao.ID > 0"   variant="success" @click="requisitarRequisicao()">
            REQUISITAR
          </b-button>
          <b-button    variant="danger" @click="fecharModalRequisicao()">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>
    
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITEM REQUISICAO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-requisicao-item" 
          id="modal-requisicao-item" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          @shown="focusModalRequisacaoItem()" 
          body-class="p-0"
          size="lg"
          headerClass= "p-2 border-bottom-0" 
          title="ITEM DA REQUISICAO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 ITEM DA REQUISICAO 
              </div>
            </div>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <bens-pesquisa 
                                      @retornaId="item.PRODUTO_ID = $event"
                                      @retornaCusto="item.VL_UNITARIO = $event"
                                      :idInicial="item.PRODUTO_ID"
                                      :classe-required="!!item.PRODUTO_ID"
                                      id="edItemPRODUTO_ID"
                                      ref="edItemPRODUTO_ID"
                                      label="Produto"
                                      place="Informe o Produto"
                                      labelBotao="">
                    </bens-pesquisa>
                  </b-form-group>
                </b-col>
              </b-row>  
              <b-row> 
                <b-col sm="4">
                </b-col> 
                <b-col sm="4">
                  <b-form-fieldset label="Estoque Disponível">
                    <vue-autonumeric  v-model="estoque.quant" 
                                      :disabled="true"
                                      ref="edEstoqueQUANT"
                                      :options="{
                                          ...formatoQuantidade
                                      }"
                                      class="form-control text-right">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                
                <b-col sm="4">
                  <b-form-fieldset label="Unidades">
                    <vue-autonumeric  v-model="item.QUANT_REQUISITADO" 
                                      ref="edQUANT_REQUISITADO"
                                      :options="{
                                        ...formatoQuantidade,
                                        minimumValue: '0',
                                        maximumValue: Number(estoque.quant || 0.00)
                                      }" 
                                      
                                      :class="['form-control text-right',
                                                {'is-invalid' : !item.QUANT_REQUISITADO,
                                                  'is-valid': !!item.QUANT_REQUISITADO
                                                }
                                              ]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
          </b-card>
        <template #modal-footer="{ cancel }">
          <b-button v-if="modalRequisicaoItem.emAlteracao == false" variant="success" @click="postItemRequisicao()">
            Gravar
          </b-button>
          <b-button v-else variant="success" @click="editItemRequisicao()">
            Gravar Alterações
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ATENDIMENTO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-atendimento" 
          id="modal-atendimento" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="ATENDIMENTO DA REQUISICAO DO ALMOXARIFADO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 ATENDIMENTO DA REQUISICAO DO ALMOXARIFADO: <strong>{{ requisicao.ID }}</strong>
              </div>
            </div>
            <b-row>
              <b-col sm="3">
                <b-form-fieldset label="Data">
                  <b-form-input  type="date" 
                                id="ob_dtDocumento" 
                                v-model="requisicao.DATA_CADASTRO"
                                :class="{'vazio': !requisicao.DATA_CADASTRO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Requisitante">
                  <b-form-input type="text" id="edUsuarioCadastro" :disabled="true"  v-model="requisicao.USUARIO_CADASTRO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Atendimento">
                  <b-form-input type="text" id="edUsuarioRequisitante" :disabled="true"  v-model="requisicao.USUARIO_ATENIMENTO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
              <b-col sm="3">
                <b-form-fieldset label="Situação">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text ><strong :class="['fa fa-circle',
                                                            colorirOP_STATUS_MODAL(requisicao.OP_STATUS)]" ></strong></b-input-group-text>
                    </template>
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzOP_STATUS(requisicao.OP_STATUS)"></b-form-input>
                  </b-input-group>
                </b-form-fieldset>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="4">
                <b-form-fieldset label="Requisitante">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeRequisitante"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Centro de Custo">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeCentroCusto"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Departamento">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeDepartamento"></b-form-input>
                </b-form-fieldset>
              </b-col>
            </b-row>
            
            
            <div>
              <b-table 
                bordered    
                striped 
                hover 
                show-empty
                empty-text="Nenhum Item"
                stacked="md"
                small
                :per-page="modalRequisicao.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="modalAtendimento.currentPage"
                :items="modalAtendimento.items" 
                :fields="modalAtendimento.fields">
                <template #cell(QUANT_ATENDIMENTO)="{ item }">
                  <b-input-group  >
                    <vue-autonumeric  v-model="item.QUANT_ATENDIMENTO" 
                                      class="form-control text-right" 
                                      :disabled="item.atendido == true"
                                      :options="{
                                        ...formatoQuantidade,
                                        minimumValue: '0',
                                        maximumValue: (item.QUANT_REQUISITADO || 0)
                                      }"  > 
                    </vue-autonumeric>
                    
                    <template #append>
                      <b-button type="button" v-if="permiteDeleteQuantAtendimento(item)" @click.stop.prevent="deleteQuantAtendimento(item)" size="sm" variant="danger " > <i class="fa fa-times"></i></b-button>
                      <b-button type="button" v-if="permitePostQuantAtendimento(item)" @click.stop.prevent="postQuantAtendimento(item)" size="sm" variant="success "> <i class="fa fa-check"></i></b-button>
                    </template>

                  </b-input-group>
                </template>
                <template #cell(STATUS_ATENDIMENTO)="item">
                  <b-badge pill :variant="colorirSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)" >{{traduzSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button variant="primary" @click.stop="finalizarAtendimento()">
            FINALIZAR
          </b-button>
          <b-button v-if="habilitaBotaoRejeitar == true" variant="outline-warning" @click.stop="rejeitarRequisicao()">
            REJEITAR
          </b-button>
          <b-button    variant="danger" @click.stop="fecharModalAtendimento()">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REQUISICAO ACOMPANHAMENTO
            ----------------------------------------------------------------------------------- -->

    <div>
      <b-modal ref="modal-requisicao-acompanhamento" 
          id="modal-requisicao-acompanhamento" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="ACOMPANHAMENTO DA REQUISICAO DO ALMOXARIFADO" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 ACOMPANHAMENTO DA REQUISICAO DO ALMOXARIFADO: <strong>{{ requisicao.ID }}</strong>
              </div>
            </div>
            <b-row>
              <b-col sm="2">
                <b-form-fieldset label="Data">
                  <b-form-input  type="date" 
                                id="ob_dtDocumento" 
                                v-model="requisicao.DATA_CADASTRO"
                                :class="{'vazio': !requisicao.DATA_CADASTRO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="2">
                <b-form-fieldset label="Atendimento">
                  <b-form-input  type="date" 
                                v-model="requisicao.DATA_ATENDIMENTO"
                                :class="{'vazio': !requisicao.DATA_ATENDIMENTO}"
                                :disabled="true" > 
                  </b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Requisitante">
                  <b-form-input type="text" id="edUsuarioCadastro" :disabled="true"  v-model="requisicao.USUARIO_CADASTRO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="3">
                <b-form-fieldset label="Usuario Atendimento">
                  <b-form-input type="text" id="edUsuarioRequisitante" :disabled="true"  v-model="requisicao.USUARIO_ATENIMENTO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              
              <b-col sm="2">
                <b-form-fieldset label="Situação">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text ><strong :class="['fa fa-circle',
                                                            colorirOP_STATUS_MODAL(requisicao.OP_STATUS)]" ></strong></b-input-group-text>
                    </template>
                    <b-form-input type="text" id="situacao" :disabled="true"  :value="traduzOP_STATUS(requisicao.OP_STATUS)"></b-form-input>
                  </b-input-group>
                </b-form-fieldset>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="4">
                <b-form-fieldset label="Requisitante">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeRequisitante"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Centro de Custo">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeCentroCusto"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <b-col sm="4">
                <b-form-fieldset label="Departamento">
                  <b-form-input type="text" :disabled="true"  v-model="modalAtendimento.nomeDepartamento"></b-form-input>
                </b-form-fieldset>
              </b-col>
            </b-row>
            
            
            <div>
              <b-table 
                bordered    
                striped 
                hover 
                show-empty
                empty-text="Nenhum Item"
                stacked="md"
                small
                :per-page="modalRequisicao.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="modalAtendimento.currentPage"
                :items="modalAtendimento.items" 
                :fields="modalAtendimento.fields">
                
                
                <template #cell(STATUS_ATENDIMENTO)="item">
                  <b-badge pill :variant="colorirSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)" >{{traduzSTATUS_ATENDIMENTO(item.item.STATUS_ATENDIMENTO)}} </b-badge>
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button    variant="danger" @click.stop="cancel">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>

    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />
  </div>
</template>

<script>
import moment from 'moment'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import VueAutonumeric from 'vue-autonumeric'
import BensPesquisa from '../../pesquisa/BensPesquisa.vue'
import CentroCustoPesquisa from '../../pesquisa/CentroCustoPesquisa.vue'
import { mapGetters } from 'vuex';

import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: { 
    SetFilter, 
    VueAutonumeric,
    BensPesquisa,
    CentroCustoPesquisa,
    ModalAlertaResultadoGrande
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'dados',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'NOME_REQUISITANTE', type: 'string', label: 'Nome' },
      { key: 'OP_STATUS',   type: 'string', label: 'Situação',
        labelMap: { '1': 'Aberta', '2': 'Parcial', '3': 'Fechada' } }
    ]
  })],

  data () {
    return {
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      // NÃO precisa de stickyHeight aqui; o mixin já cuida ☑
      colunas: [
        {
          key: "DETALHE",
          class:'align-middle text-center p-0',
          label: '',
          sortable: true,
          thStyle: { width: "2%" }
        },
        {
          key: "ID",
          label: 'Requisição',
          class:'align-middle text-right',
          thStyle: { width: "5%" },
          sortable: true,
        },
        {
          key: "DATA_CADASTRO",
          label: 'Cadastro', 
          thStyle: { width: "7%" },
          class:'align-middle text-right',
          sortable: true,
          
          formatter: (value, key, item) => 
            value = value ? moment(String(value)).format('DD/MM/YYYY') : null
        },
        {
          key: "OP_STATUS",
          label: 'Situação', 
          class:'align-middle',
          thStyle: { width: "5%" },
          sortable: true,
        },
        {
          key: "DATA_ATENDIMENTO",
          label: 'Atendimento', 
          thStyle: { width: "10%" },
          sortable: true,
          
          class:'text-right align-middle',
          formatter: (value, key, item) => 
            value = value ? moment(String(value)).format('DD/MM/YYYY') : null
        },
        {
          key: "NOME_REQUISITANTE",
          label: 'Requisitante', 
          class:'align-middle',
          thStyle: { width: "15%" },
          sortable: true,
        },
        {
          key: "NOME_CENTRO_CUSTO",
          label: 'Centro Custo', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true,
        },
        {
          key: "NOME_USUARIO_ATENDIMENTO",
          label: 'Atendendente', 
          class:'align-middle',
          thStyle: { width: "10%" },
          sortable: true,
        },
        {
          key: "DEPARTAMENTO_ID",
          label: 'Depto', 
          class:'align-middle',
          thStyle: { width: "5%" },
          sortable: true,
        },
        {
          key: 'TOTAL', 
          class:'text-right', 
          thStyle: { width: "10%" },
          label: 'Total (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
              value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0
        },
          {
            key: "QUANT",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            sortable: true,
            formatter: (value, key, item) => 
               value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
        {
          key: "actions" ,
          class:'text-right align-middle p-0', 
          thStyle: { width: "10%" },
          label: 'Ações', 
        }
      ],
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimal: ',',
        precision: 3
      },
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        prefix: 'R$: ',
        modifyValueOnWheel: false
        
      },
      optionsREQUISITANTE_ID: [],
      optionsCENTRO_CUSTO_ID: [],
      optionsDEPARTAMENTO_ID: [],
      estoque:{
        produtoId: null,
        quant: 0,
        pecas: 0,
        maximumValue: 0

      },
      modalRequisicaoItem: {
        emAlteracao: false,
      },
      modalRequisicao: {
        emAlteracao: false,
        perPage: 20,
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "ID",
            headerName: 'Requisição',
            class:'align-middle text-right',
            thStyle: { width: "5%" },
            sortable: true
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto', 
            class:'align-middle',
            thStyle: { width: "55%" },
            sortable: true 
          },
          {
            key: "OP_CONSUMIVEL",
            label: 'Cons', 
            class:'align-middle',
            thStyle: { width: "5%" },
            sortable: true 
          },
          {
            key: "QUANT_REQUISITADO",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_RESTANTE",
            label: 'Restante',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "STATUS_ATENDIMENTO",
            label: 'Atendimento', 
            class:'align-middle text-center',
            thStyle: { width: "15%" },
            sortable: true 
          },
          {
            key: "actions" ,
            class:'text-right', 
            thStyle: { width: "5%" },
            label: 'Ações' 
          }
        ],

      },
      requisicao: {
        ID                         : null,
        DATA_CADASTRO              : null,
        DATA_ALTERACAO             : null,
        DATA_EXCLUSAO              : null,
        USUARIO_CADASTRO           : null,
        USUARIO_ALTERACAO          : null,
        USUARIO_EXCLUSAO           : null,
        OBSERVACAO_REQUISICAO      : null,
        CENTRO_CUSTO_ID            : null,
        DEPARTAMENTO_ID            : null,
        CENTRO_ESTOQUE_ORIGEM_ID   : null,
        CENTRO_ESTOQUE_DESTINO_ID  : null,
        OP_STATUS                  : null,
        USUARIO_ATENIMENTO         : null,
        DATA_ATENDIMENTO           : null,
        USUARIO_REQUISICAO_ID      : null,
        OBSERVACAO_ATENDIMENTO     : null,
        USUARIO_ATENDIMENTO_ID     : null,
        USUARIO_ALTERACAO_ID       : null,
        DATA_NECESSIDADE           : null,
        REQUISITANTE_ID            : null,
      },
      item: {
        ID                 : null,
        ALMOXARIFADO_ID    : null,
        QUANT_REQUISITADO  : null,
        OBSERVACAO         : null,
        PRODUTO_ID         : null,
        VL_UNITARIO        : null,
        OP_CONSUMIVEL      : null,
        QUANT_UTILIZADO    : null,
        QUANT_ATENDIMENTO  : null,
        CENTRO_ESTOQUE_ID  : null,
      },
      modalAtendimento: {
        emAlteracao: false,
        perPage: 20,
        currentPage: 1,
        nomeRequisitante: null,
        nomeCentroCusto: null,
        nomeDepartamento: null,
        items: [],
        fields: [
          {
            key: "PRODUTO_ID",
            label: 'Id',
            class:'align-middle text-right',
            thStyle: { width: "5%" },
            sortable: true
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto', 
            class:'align-middle',
            thStyle: { width: "35%" },
            sortable: true 
          },
          {
            key: "QUANT_ESTOQUE",
            label: 'Estoque',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_REQUISITADO",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_ATENDIMENTO",
            label: 'Atendido', 
            class:'align-middle',
            thStyle: { width: "20%" },
            sortable: true 
          },
          {
            key: "QUANT_RESTANTE",
            label: 'Restante',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "STATUS_ATENDIMENTO",
            label: 'Quantidade Atendimento', 
            class:'align-middle text-center',
            thStyle: { width: "10%" },
            sortable: true 
          }
        ],

      },
      
      statusOptions: [
        {text: 'CANCELADA', value: '0'},
        {text: 'REQUISITADA', value: '1'},
        {text: 'EM ATENDIMENTO', value: '2'},
        {text: 'ATENDIDA', value: '3'},
        {text: 'DEVOLVIDA', value: '4'},
        {text: 'ARQUIVADA', value: '5'}
      ],
      detalhes: {
        fields: [
          {
            key: "ID",
            label: 'Requisição',
            class:'align-middle text-right',
            thStyle: { width: "5%" }
          },
          {
            key: "NOME_PRODUTO",
            label: 'Produto', 
            class:'align-middle',
            thStyle: { width: "55%" }
          },
          {
            key: "OP_CONSUMIVEL",
            label: 'Cons', 
            class:'align-middle',
            thStyle: { width: "5%" }
          },
          {
            key: "QUANT_REQUISITADO",
            label: 'Quantidade',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "QUANT_RESTANTE",
            label: 'Restante',
            thStyle: { width: "10%" },
            class:'text-right align-middle', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0
          },
          {
            key: "STATUS_ATENDIMENTO",
            label: 'Atendimento', 
            class:'align-middle text-center',
            thStyle: { width: "15%" }
          }
        ],

      },
    }
  },

  methods: {
    // Esses dois métodos garantem que eventos da CecPageBar
    // atualizem a store (e o mixin faz o resto).
    onPageChange (p) { this.currentPage = p },
    onPerPageChange (n) { this.perPage = n; this.currentPage = 1 },

    // INICIO DOS METODOS DE NEGOCIO
    async pesquisar () {
      // Impede pesquisa se o modal está aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      try {
        this.$store.commit('controle/setAguardando', true)
        
        // Remove o foco dos inputs antes de abrir modal
        const inputs = [this.$refs.dt1, this.$refs.dt2]
        inputs.forEach(input => {
          if (input && input.$el) input.$el.blur()
          else if (input && input.blur) input.blur()
        })
        
        const result = await this.$store.dispatch('almoxarife/GET_LISTA')
        
        // Verifica se precisa de confirmação
        if (result && result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      try {
        // Pass skipConfirmation: true to force load
        await this.$store.dispatch('almoxarife/GET_LISTA', { skipConfirmation: true })
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (error) {
        this.$root.$bvToast.toast(`Falha ao carregar os registros: ${error.message}`, {
          title: 'Falha',
          autoHideDelay: 5000,
          variant: 'danger',
          appendToast: true
        })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelarCarregarResultadoGrande() {
      // Apenas fecha o modal e limpa os dados pendentes
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      this.$root.$bvToast.toast('Carregamento de resultado grande cancelado', {
        title: 'Informação',
        autoHideDelay: 5000,
        variant: 'info',
        appendToast: true
      })
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions' && f.key !== 'DETALHE'),
        reportTitle: 'Listagem de Requisições',
        printedBy: window.localStorage.getItem('login') ?? '—',
        filename: 'requisicoes.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions' && f.key !== 'DETALHE'),
        filename: 'requisicoes.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(f => f.key !== 'actions' && f.key !== 'DETALHE'),
        filename: 'requisicoes.csv',
      });
    },
    focusModalRequisacaoItem() {
      this.$refs.edItemPRODUTO_ID.$refs.auto.$refs.autocomplete.focus()
    },
    async toggleDetalhesListagem(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      this.$store.commit("almoxarife/SET_REGISTRO_SELECIONADO_ID", row.item.ID)

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)

        const detalhes = await this.carregarDetalhesRequisicao(row.item.ID)

        this.$set(row.item, 'detalhes', detalhes)
        this.$set(row.item, 'loading', false)
      }

      row.toggleDetails()
    },
    abrirModalRequisicaoAdd () {
      // TODO: estoure seu modal real
      // this.$bvModal.show('id-do-seu-modal');
    },
    async rejeitarRequisicao() {
      this.$bvModal.msgBoxOk('Operação não permitida! Deixe vazio os itens e Encerre o Atendimento!', {
          title: 'Rejeitar',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
    },
    async deleteProduto() {
      this.$bvModal.msgBoxOk('Operação não permitida', {
          title: 'Remover',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'danger',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      
    },
    async carregarUsuarios() {
      try {
        const {data}  = await this.$http.get('/api/protected/funcionario/listar')
        this.optionsREQUISITANTE_ID = [{value: null, text: ''}]
        for (const und of data ) {
          this.optionsREQUISITANTE_ID.push({value: und.CODIGO, text: `${und.NOME} - ${und.CODIGO}`})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Requisitantes!')
        return
      }
    },
    async carregarCentroCusto() {
      try {
        const {data}  = await this.$http.get('/api/protected/centrocusto/listarTodos')
        this.optionsCENTRO_CUSTO_ID = [{value: null, text: ''}]
        for (const und of data ) {
          this.optionsCENTRO_CUSTO_ID.push({value: und.CODIGO, text: `${und.DESCRICAO} - ${und.CODIGO}`})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Centros de Custo!')
        return
      }
    },
    async carregarDepartamento() {
      try {
        const {data}  = await this.$http.get('/api/protected/departamento/listarTodos')
        this.optionsDEPARTAMENTO_ID = [{value: null, text: ''}]
        for (const und of data ) {
          this.optionsDEPARTAMENTO_ID.push({value: und.ID, text: `${und.NOME} - ${und.ID}`})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Departamentos!')
        return
      }
    },
    async carregarItensRequisicao() {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getByRequisicaoId/${this.requisicao.ID}`)
        this.modalRequisicao.items = data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar os Itens!')
        return
      }
    },
    async carregarItensAtendimento() {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getItensAtendimento/${this.requisicao.ID}`)
        this.modalAtendimento.items = data.map(item => ({
          ...item,
          atendido: item.QUANT_ATENDIMENTO > 0
        }))
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar os Itens!')
        return
      }
    },
    async carregarDetalhesRequisicao(id) {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getByRequisicaoId/${id}`)
        return data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar os Itens!')
        return
      }
    },
    async carregarEstoqueDoProduto(id) {
      try {
        const {data}  = await this.$http.get(`/api/protected/almoxarife/item/getEstoqueByProdutoId/${id}`)
        this.estoque.quant = (data?.[0]?.QUANT) ?? 0.0
        this.estoque.pecas = (data?.[0]?.PECAS) ?? 0.0
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi verificar o estoque do Produto!')
        return
      }
    },
    async requisitarRequisicao() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          requisicao: this.requisicao,
          login: window.localStorage.getItem('nomeusuario')
        }
        await this.$http.post('/api/protected/almoxarife/requisitar', requisicaoPayload )
        await this.pesquisar()
        this.$refs['modal-requisicao'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    async abrirModalRequisicaoAdd() {
      this.requisicao.ID                         = null
      this.requisicao.DATA_CADASTRO = Tools.getDataAtual()
      this.requisicao.DATA_ALTERACAO             = null
      this.requisicao.DATA_EXCLUSAO              = null
      this.requisicao.USUARIO_CADASTRO           = window.localStorage.getItem('nomeusuario')
      this.requisicao.USUARIO_ALTERACAO          = null
      this.requisicao.USUARIO_EXCLUSAO           = null
      this.requisicao.OBSERVACAO_REQUISICAO      = null
      this.requisicao.CENTRO_CUSTO_ID            = null
      this.requisicao.DEPARTAMENTO_ID            = null
      this.requisicao.CENTRO_ESTOQUE_ORIGEM_ID   = null
      this.requisicao.CENTRO_ESTOQUE_DESTINO_ID  = null
      this.requisicao.OP_STATUS = '6' //Em cadastramento
      this.requisicao.USUARIO_ATENIMENTO         = null
      this.requisicao.DATA_ATENDIMENTO           = null
      this.requisicao.USUARIO_REQUISICAO_ID      = null
      this.requisicao.OBSERVACAO_ATENDIMENTO     = null
      this.requisicao.USUARIO_ATENDIMENTO_ID     = null
      this.requisicao.USUARIO_ALTERACAO_ID       = null
      this.requisicao.DATA_NECESSIDADE           = null
      this.requisicao.REQUISITANTE_ID            = null
      this.modalRequisicao.emAlteracao = false
      
      const loaders = [
        this.carregarUsuarios(),
        this.carregarCentroCusto(),
        this.carregarDepartamento()
      ]
      await Promise.all(loaders)

      this.modalRequisicao.items = []
      this.$refs['modal-requisicao'].show()

    },
    async abrirModalRequisicaoEdit(item) {
      try {
        if (!['6'].includes(item.OP_STATUS)) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Não é permitido alterar a requisição selecionada!' )
          return
        }

        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        
        const loaders = [
          this.carregarUsuarios(),
          this.carregarCentroCusto(),
          this.carregarDepartamento(),
          this.carregarItensRequisicao()
        ]
        await Promise.all(loaders)

        this.$store.commit("almoxarife/SET_REGISTRO_SELECIONADO_ID", item.ID)
        this.modalRequisicao.emAlteracao = true
        this.$refs['modal-requisicao'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async abrirModalItemRequisicaoAdd() {
      try {
        this.$store.commit('controle/setAguardando', true)

        //A requisicao ainda nao foi gravada no banco de dados
        if (!this.requisicao.ID) {
          const requisicaoPayload = {
            requisicao: this.requisicao,
            usuarioId:  window.localStorage.getItem('usuarioId')
          }
          const {data} = await this.$http.post('/api/protected/almoxarife/post', requisicaoPayload )
          this.requisicao = {...data.requisicao ?? null}
          this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
          this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)

          this.$store.commit("almoxarife/SET_REGISTRO_SELECIONADO_ID", this.requisicao.ID)
        }  

        this.item.ID                 = null,
        this.item.ALMOXARIFADO_ID    = this.requisicao.ID
        this.item.QUANT_REQUISITADO  = 0.00
        this.item.OBSERVACAO         = null
        this.item.PRODUTO_ID         = null
        this.item.VL_UNITARIO        = null
        this.item.OP_CONSUMIVEL      = null
        this.item.QUANT_UTILIZADO    = null
        this.item.QUANT_ATENDIMENTO  = null
        this.item.CENTRO_ESTOQUE_ID  = null
        //this.item.CENTRO_ESTOQUE_ID =  qrParametrosCENTRO_ESTOQUE_ALMOXARIFADO_ID.asInteger;
        this.modalRequisicaoItem.emAlteracao = false
        this.$refs['modal-requisicao-item'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalItemRequisicaoEdit(item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/item/getById/${item.ID}`)
        this.item = {...data?.[0]} ?? {}
        this.modalRequisicaoItem.emAlteracao = true
        this.$refs['modal-requisicao-item'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async postItemRequisicao() {
      if (this.item.QUANT_REQUISITADO <= 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Quantidade'  )
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          requisicao: this.item
        }
        await this.$http.post('/api/protected/almoxarife/item/post', requisicaoPayload )
        await this.carregarItensRequisicao()
        this.$refs['modal-requisicao-item'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteItemRequisicao(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Remover o ${item.NOME_PRODUTO} da Requisição?`, {
        title: 'remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          id: item.ID,
          requisicaoId: item.ALMOXARIFADO_ID,
          login: window.localStorage.getItem('nomeusuario')
        }
        await this.$http.post('/api/protected/almoxarife/item/delete', requisicaoPayload )
        await this.carregarItensRequisicao()
        this.$refs['modal-requisicao-item'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editItemRequisicao() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const requisicaoPayload = {
          requisicao: this.item
        }
        await this.$http.post('/api/protected/almoxarife/item/edit', requisicaoPayload )
        await this.carregarItensRequisicao()
        this.$refs['modal-requisicao-item'].hide()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalAtendimento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.USUARIO_ATENDIMENTO_ID = window.localStorage.getItem('usuarioId')
        this.requisicao.USUARIO_ATENIMENTO = window.localStorage.getItem('nomeusuario')

        
        
        const loaders = [
          this.carregarUsuarios(),
          this.carregarCentroCusto(),
          this.carregarDepartamento(),
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

        this.modalAtendimento.nomeCentroCusto =  this.optionsCENTRO_CUSTO_ID.find(el => el.value === this.requisicao.CENTRO_CUSTO_ID)?.text || null;
        this.modalAtendimento.nomeRequisitante =  this.optionsREQUISITANTE_ID.find(el => el.value === this.requisicao.REQUISITANTE_ID)?.text || null;
        this.modalAtendimento.nomeDepartamento =  this.optionsDEPARTAMENTO_ID.find(el => el.value === this.requisicao.DEPARTAMENTO_ID)?.text || null;

        this.$store.commit("almoxarife/SET_REGISTRO_SELECIONADO_ID", item.ID)
        this.$refs['modal-atendimento'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async fecharModalAtendimento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        await this.pesquisar()
        this.$refs['modal-atendimento'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async fecharModalRequisicao() {
      if (!this.requisicao.ID) {
        this.$refs['modal-requisicao'].hide()
        return 
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.pesquisar()
        this.$refs['modal-requisicao'].hide()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async abrirModalAcompanhamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        this.requisicao.USUARIO_ATENDIMENTO_ID = window.localStorage.getItem('usuarioId')
        this.requisicao.USUARIO_ATENIMENTO = window.localStorage.getItem('nomeusuario')

        
        
        const loaders = [
          this.carregarUsuarios(),
          this.carregarCentroCusto(),
          this.carregarDepartamento(),
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

        this.modalAtendimento.nomeCentroCusto =  this.optionsCENTRO_CUSTO_ID.find(el => el.value === this.requisicao.CENTRO_CUSTO_ID)?.text || null;
        this.modalAtendimento.nomeRequisitante =  this.optionsREQUISITANTE_ID.find(el => el.value === this.requisicao.REQUISITANTE_ID)?.text || null;
        this.modalAtendimento.nomeDepartamento =  this.optionsDEPARTAMENTO_ID.find(el => el.value === this.requisicao.DEPARTAMENTO_ID)?.text || null;

        this.$store.commit("almoxarife/SET_REGISTRO_SELECIONADO_ID", item.ID)
        this.$refs['modal-requisicao-acompanhamento'].show()
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    clicarLinha(item) {
      this.$store.commit("almoxarife/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['almoxarife/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    rowClassSelecionadoItem(item, type) {
      return ''
      
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    traduzSTATUS_ATENDIMENTO(valor) {
      switch (valor) {
        case '0':
          return 'Atendido'
        case '1':
          return 'Incompleto'
        case '2':
          return 'Passou'
        default:
          return ''
      }
    },
    colorirSTATUS_ATENDIMENTO(valor) {
      switch (valor) {
        case '0':
          return 'success'
        case '1':
          return 'warning'
        case '2':
          return 'danger'
        default:
          return ''
      }
    },
    traduzOP_STATUS(valor) {
      switch (valor) {
        case '0':
          return 'Cancelada'
        case '1':
          return 'Requisitada'
        case '2':
          return 'Em Atendimento'
        case '3':
          return 'Atendido'
        case '4':
          return 'Devolvido'
        case '5':
          return 'Arquivado'
        case '6':
          return 'Em Cadastro'  
        default:
          return ''
      }
    },
    colorirOP_STATUS(valor) {
      switch (valor) {
        case '0':
          return 'danger'
        case '1':
          return 'info'
        case '2':
          return 'primary'
        case '3':
          return 'success'
        case '4':
          return 'gray-200'
        case '5':
          return 'secondary'  
        case '6':
          return 'warning'    
        default:
          return ''
      }
    },
    colorirOP_STATUS_MODAL(valor) {
      switch (valor) {
        case '0':
          return 'text-danger'
        case '1':
          return 'text-info'
        case '2':
          return 'text-primary'
        case '3':
          return 'text-success'
        case '4':
          return 'text-gray-200'
        case '5':
          return 'text-secondary'  
        case '6':
          return 'text-warning'    
        default:
          return ''
      }
    },

    limparFiltro() {
      this.$store.commit("almoxarife/SET_LIMPAR", null);
    },
    async postQuantAtendimento(item){
      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadItem = {
          requisicaoId: this.requisicao.ID,
          id: item.ID,
          produtoId: item.PRODUTO_ID,
          quant: item.QUANT_ATENDIMENTO,
          login: window.localStorage.getItem('nomeusuario')
        }

        await this.$http.post(`/api/protected/almoxarife/item/editAtendimento`, payloadItem)
        

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ALMOXARIFADO_ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        const loaders = [
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async deleteQuantAtendimento(item){
      const msg = await this.$bvModal.msgBoxConfirm(`Remover o ${item.NOME_PRODUTO} atendimento?`, {
        title: 'remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        const payloadItem = {
          requisicaoId: this.requisicao.ID,
          id: item.ID,
          produtoId: item.PRODUTO_ID,
          quant: 0,
          login: window.localStorage.getItem('nomeusuario')
        }

        await this.$http.post(`/api/protected/almoxarife/item/editAtendimento`, payloadItem)
        

        const {data} = await this.$http.get(`/api/protected/almoxarife/getById/${item.ALMOXARIFADO_ID}`)
        this.requisicao = {...data?.[0]} ?? {}
        this.requisicao.DATA_CADASTRO = Tools.formatarDataParaInput(this.requisicao.DATA_CADASTRO)
        this.requisicao.DATA_ATENDIMENTO = Tools.formatarDataParaInput(this.requisicao.DATA_ATENDIMENTO)
        
        const loaders = [
          this.carregarItensAtendimento()
        ]
        await Promise.all(loaders)

      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async finalizarAtendimento() {
      let naoAtendidos = this.modalAtendimento.items.length 
        ? this.modalAtendimento.items.every(item => item.QUANT_RESTANTE > 0 ) 
        : true

      const mensagem = (naoAtendidos == true)
        ? `Existem itens não atendido, ou incompletos!!! Finalizar o atendimento?`
        : `Finalizar o atendimento?`
        
      const msg = await this.$bvModal.msgBoxConfirm(mensagem, {
        title: 'Finalizar',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return
      
      try {
        const finalizarPayload = {
          requisicao: this.requisicao,
          login: window.localStorage.getItem('nomeusuario')
        }
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post('/api/protected/almoxarife/finalizar', finalizarPayload )
        await this.pesquisar()
        this.$refs['modal-atendimento'].hide()

      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    permiteDeleteQuantAtendimento(item) {
      return item.atendido == true
    },
    permitePostQuantAtendimento(item) {
      return item.atendido == false
    },
    
    handleKeydown(event) {
    },
    async imprimirRequisicao (item) {
      console.log(item)
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          this.$store.commit("bens/SET_REGISTRO_SELECIONADO_ID", item.ID)
          const relPayLoad = {
            id: item.ID,
            usuario: window.localStorage.getItem('nomeusuario')
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/almoxarife/requisicao`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relRequisicao.pdf') 
          link.download = 'relRequisicao.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = item.ID +' Requisicao do Almoxarifado'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async imprimirAtendimento (item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          this.$store.commit("bens/SET_REGISTRO_SELECIONADO_ID", item.ID)
          const relPayLoad = {
            id: item.ID,
            usuario: window.localStorage.getItem('nomeusuario')
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/almoxarife/atendimento`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relRequisicao.pdf') 
          link.download = 'relAtendimento.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = item.ID +' Ticket de Atendimento'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
  },
  computed: {
    ...mapGetters('tema',{isDark: 'IS_DARK'}),

    currentPage: {
      get () {
        return this.$store.getters['almoxarife/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("almoxarife/SET_PAGINA_ATUAL", Number(value) || 1);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['almoxarife/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('almoxarife/SET_PER_PAGE', Number(v) || 25)
      }
    },
    dt1: {
      get () {
        return this.$store.getters['almoxarife/DT1']
      }, 
      set (value) {
        this.$store.commit("almoxarife/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['almoxarife/DT2']
      }, 
      set (value) {
        this.$store.commit("almoxarife/SET_DT2", value);
      }
    },
    
    dados: {
      get () {
        return this.$store.getters['almoxarife/LISTA']
      }, 
      set (value) {
        this.$store.commit("almoxarife/SET_LISTA", value);
      }
    },
    habilitaBotaoRejeitar() {
    // retorna true somente se TODOS os itens tiverem QUANT_ATENDIMENTO = 0
      return this.modalAtendimento.items.length 
        ? this.modalAtendimento.items.every(item => item.QUANT_ATENDIMENTO === 0) 
        : false
    }
  },
  async created() {
    this.$store.commit('controle/setAguardando', false)  
    await this.pesquisar()
  }
}
</script>
<style >
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky */
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #adbac3 !important;
}


</style>



// WEBPACK FOOTER //
// src/views/almoxarifado/requisicao/RequisicaoListagem.vue